import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PageComponent } from './page.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      { path:'PageModule', loadChildren: () => import('./page.module').then(m => m.PageModule)},
      { path: '', component: PageComponent }
    ])
  ],
  exports: [RouterModule]
})
export class PageRoutingModule { }
